import axiosInstance from './axios';

export interface SiteStatisticsParams {
  siteId: string | number;
  from: string;
  to: string;
}

export interface BonusStatistic {
  type: string;
  count: number | null;
  activated: number;
  notActivated: number;
  amount: string | null;
}

export interface SiteStatisticsData {
  deposits: {
    total: string;
  };
  withdrawals: {
    total: string;
    completed: string;
    inProcess: string;
  };
  financeCommission: string;
  activeUsers: number;
  newUsers: number;
  ftdUsers?: number;
  firstDepositUsers?: number;
  bonuses: BonusStatistic[];
  gamesCommission: string;
  siteProfit: string;
}

export interface SiteStatisticsResponse {
  data: SiteStatisticsData;
  error: string | null;
  message: string;
  status: number;
}

export const statisticsService = {
  getSiteStatistics: async (params: SiteStatisticsParams): Promise<SiteStatisticsResponse> => {
    const response = await axiosInstance.get('/admin/statistics/site', { params });
    return response.data;
  },
  getPaymentSystems: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/payment-systems', { params });
    return response.data;
  },
  getGameSystems: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/game-systems', { params });
    return response.data;
  },
  getActiveUsers: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/active-users', { params });
    return response.data;
  },
  getFirstDepositUsers: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/first-deposit-users', { params });
    return response.data;
  },
  getWheelSpins: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/wheel-spins', { params });
    return response.data;
  },
  getWheelPendingSpins: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/wheel-pending-spins', { params });
    return response.data;
  },
  getBonusClaims: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/statistics/bonus-claims', { params });
    return response.data;
  },
};
